import {AfterViewInit, Component, OnDestroy, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ChangeDetectorRef, forwardRef} from "@angular/core";
import  Pikaday from 'pikaday';
import { FormBuilder, FormGroup, NG_VALUE_ACCESSOR } from "@angular/forms";
import { debounceTime, Subject, Subscription } from "rxjs";
import { DateUtil } from "../../utils/date.util";
/**
 * declare Jquery
 * */
declare let $: any;

@Component({
  selector: 'input-date',
  templateUrl: "./input-date.html",
  styleUrls: ['./input-date.scss'],
  providers: [
    {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => InputDateComponent),
    multi: true
    }
]
})

export class InputDateComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
    @Input('id') id: string = '' + Math.round(Math.random() * 1000) + Math.round(Math.random() * 1000);
    @Input('value') value: any;
    @Input('min') min: any;
    @Input('max') max: any;
    @Input('placeholder') placeholder: any = 'dd/mm/yyyy';
    @Input('format') format: string = 'dd/MM/yyyy';
    @Input('disabled') disabled: boolean = false;
    @Input('isNoInput') isNoInput: boolean = false;
    @Input('isError') isError: boolean = false;
    @Input('isNoPast') isNoPast: boolean = false;
    @Input('isNoCurrentDate') isNoCurrentDate: boolean = false;
    @Input('isNoFuture') isNoFuture: boolean = false;
    @Input('image') image: any;
    @Output() result: EventEmitter<any> = new EventEmitter();
    @Output() valueChange: EventEmitter<any> = new EventEmitter();
    formDate: FormGroup = this.formBuilder.group({
        textInput: [''],
        textShow: [''],
        text: [''],
    });
    time: any;
    picker: any;
    date: any;
    onChange: any = () => { };
    onTouched: any = () => { };
    subscriptions?: Subscription[] = [];
    emitData$ = new Subject();
    constructor(
        private cdf: ChangeDetectorRef,
        private formBuilder: FormBuilder,
    ) {

    }
    ngOnInit() {
        this.id = Math.floor(Math.random() * 1000) + '-' + Math.floor(Math.random() * 1000);
        $(window).keydown((event) => {
            const selection: any = document.getSelection();
            if (selection.toString() && selection.extentNode.id === 'input-group-' + this.id ) {
                this.catchKeydownTextShow(event)
                return;
            }
        });
        this.subscriptions = [...[
            this.emitData$.pipe(
              debounceTime(200),
              ).subscribe((event)=> { return this.emitData();}),
            this.formDate.get("textInput").valueChanges.subscribe((val) => {
                this.parseTextShow(val);
            }),
        ]];
    }
    ngAfterViewInit(): void {
        const yearRange = [1900, 2100];
        if  (this.isNoPast) {
            const currentDate = DateUtil.getCurrentDateNoTime();
            if (this.isNoCurrentDate) {
                currentDate.setDate(currentDate.getDate() + 1);
            }
            this.min = currentDate.getTime();
            yearRange[0] = new Date().getFullYear();
        }
        if  (this.isNoFuture) {
            const currentDate = DateUtil.getCurrentDateNoTime();
            if (this.isNoCurrentDate) {
                currentDate.setDate(currentDate.getDate() - 1);
            }
            this.max = Date.now();
            yearRange[1] = new Date().getFullYear();
        }
        const func = this.changeValue.bind(this);
        this.picker = new Pikaday({
            field: document.getElementById('datepicker' + this.id),
            format: this.format,
            toString(date, format) {
                func(date.getTime());
                return DateUtil.parseDate(date, this.format);
            },
            parse(dateString, format) {
                const parts = dateString.split('/');
                const day = parseInt(parts[0], 10);
                const month = parseInt(parts[1], 10) - 1;
                const year = parseInt(parts[2], 10);
                return new Date(year, month, day);
            },
            minDate: this.min ? new Date(this.min) : undefined,
            maxDate: this.max ? new Date(this.max) : undefined,
            yearRange,
            keyboardInput: true
        });
        this.moveToDate();
        $('#text-show-' + this.id).on('keydown', (event) => {
            this.catchKeydownTextShow(event)
        });
    }
    moveToDate() {
        if (this.picker) {
            const minDate = this.min ? new Date(this.min) : undefined;
            const maxDate = this.max ? new Date(this.max) : undefined;
            if ((!minDate || minDate <= this.date) && (!maxDate || this.date <= maxDate) ) {
                this.picker.setDate(DateUtil.parseDate(this.date, 'yyyy-MM-dd'));
            }
        }
    }
    ngOnChanges(changes: SimpleChanges) {
        if (changes.value && changes.value.currentValue !== changes.value.previousValue) {
            this.setDate(changes.value.currentValue);
        }
    }
    ngOnDestroy(): void {
        for (const subscriber of this.subscriptions) {
            subscriber.unsubscribe();
        }
    }
    writeValue(currentValue: any): void {
        this.setDate(currentValue);
    }
    registerOnChange(fn: any): void {
        this.onChange = fn;
    }
    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }
    
    setDate(currentValue) {
        if (!currentValue) {
            this.formDate.patchValue({
                text: '',
                textShow : ''
            })
            return;
        }
        if (this.time === currentValue || this.time === new Date(currentValue).getTime()) {
            return;
        }
        this.date =  typeof currentValue === 'string' ? DateUtil.revertDate(currentValue , this.format) : new Date(currentValue);
        this.moveToDate();
        this.formDate.patchValue({
            textInput: DateUtil.parseDate(this.date , this.format),
        })
    }
    changeValue(val) {
        const value  = DateUtil.parseDate(val, this.format);
        if (value === this.value) {
            return;
        }
        this.formDate.patchValue({
            textInput: value,
        })
        this.emitData$.next(true);
    }
    catchKeydown(event) {
        const key = event.key;

        if (key === 'Backspace' || key === 'ArrowLeft' || key === 'ArrowRight' || key === 'Tab' || key === 'Delete') {
          
            if (key === 'Backspace' || key === 'Delete') {
                this.formDate.patchValue({
                    textInput: '',
                })
            }
            return;
        }

        if (key >= '0' && key <= '9') {
            this.formDate.patchValue({
                textInput: this.formDate.value.textInput += key,
            })
        }
        event.preventDefault();
    }
    parseTextShow(textInput) {
        // console.log('parseTextShow: ', textInput);
        let textNumber = (textInput || '').replaceAll('/', '');
        let day: any = textNumber.substring(0,2);
        if (parseInt(day) > 31) {
            day = '31';
        }
        let month: any = textNumber.substring(2,4);
        if (parseInt(month) > 12) {
            month = '12';
        }
        let textParse = `${day}${month ? '/' + month : ''}${textNumber.substring(4,8) ? '/' + textNumber.substring(4,8) : ''}`;
        this.formDate.patchValue({
            textShow: textParse,
        })
        setTimeout(() => {
            this.formDate.patchValue({
                text: textInput ?  '  ' : undefined,
            })
        }, 10)
        if (textParse.length === 10) {
            this.emitData$.next(true);
        }
        this.cdf.detectChanges();
    }
    catchKeydownTextShow(event) {
        const key = event.key;
        if (key === 'Backspace' || key === 'Delete') {
            this.formDate.patchValue({
                textInput: '',
            })
        }
    }
    emitData() {
        if (this.formDate.value.textShow && this.format) {
            const date = DateUtil.revertDate(this.formDate.value.textShow, this.format);
            this.time = date.getTime();
        } else {
            this.time = null;
        }
        // console.log('emit Data: ', this.time);
        this.onChange(this.time);
        this.valueChange.emit(this.time);
        setTimeout(() => {
            this.result.emit(this.time);
        }, 200)
    }
    toggleCalendar() { 
        this.picker.show();
    };
}
